/* eslint-disable no-useless-catch */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

import RegisterService from "../services/RegisterService";

export function create(email: string, password: string, solera?: any, eligibility_id?: string) {
    return async () => {
        try {
            const response = await RegisterService.create(email, password, solera, eligibility_id);
            const { token } = response.data;
            if (token !== '') {
                localStorage.setItem('token', response.data.token as string);
                window.location.href = "/app/dashboard";
            } else {
                window.location.href = "/registered";
            }
        } catch (error) {
            throw error;
        }
    }
}
